/**
 * Status badge component for displaying user status
 */

import type { UserStatus } from "@eoln/userpool/types";

interface UserStatusBadgeProps {
  status: UserStatus;
}

const statusStyles: Record<UserStatus, { bg: string; text: string; label: string }> = {
  PENDING: { bg: "bg-yellow-100", text: "text-yellow-800", label: "Pending" },
  ACTIVE: { bg: "bg-green-100", text: "text-green-800", label: "Active" },
  SUSPENDED: { bg: "bg-orange-100", text: "text-orange-800", label: "Suspended" },
  DISABLED: { bg: "bg-gray-100", text: "text-gray-800", label: "Disabled" },
  LOCKED: { bg: "bg-red-100", text: "text-red-800", label: "Locked" },
  DELETED: { bg: "bg-gray-100", text: "text-gray-500", label: "Deleted" },
};

export function UserStatusBadge({ status }: UserStatusBadgeProps) {
  const style = statusStyles[status] || { bg: "bg-gray-100", text: "text-gray-800", label: status };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style.bg} ${style.text}`}
    >
      {style.label}
    </span>
  );
}
